import { render, staticRenderFns } from "./product-grid.vue?vue&type=template&id=8beec692&scoped=true"
import script from "./product-grid.vue?vue&type=script&lang=js"
export * from "./product-grid.vue?vue&type=script&lang=js"
import style0 from "./product-grid.vue?vue&type=style&index=0&id=8beec692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8beec692",
  null
  
)

export default component.exports